import { useMemo, useRef } from 'react';

import DataTable from 'components/DataTableComponent/DataTable';

import { TABLE_VIEW_DEFAULTS } from './TableView.constants';
import { TableViewProps } from './TableView.types';

export const TableView = <T extends object>({
  title,
  data,
  columns,
  isLoading,
  rowIdIdentifier = TABLE_VIEW_DEFAULTS.ROW_ID,
  stickyHeader = TABLE_VIEW_DEFAULTS.STICKY_HEADER,
  rowsPerPage = TABLE_VIEW_DEFAULTS.ROWS_PER_PAGE,
  enableColumnResizing = TABLE_VIEW_DEFAULTS.ENABLE_COLUMN_RESIZING,
  showPagination = TABLE_VIEW_DEFAULTS.SHOW_PAGINATION
}: TableViewProps<T>) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const memoizedColumns = useMemo(() => columns, [columns]);

  return (
    <div className="flex flex-col gap-4 h-full w-full">
      <div className="flex flex-col gap-4 border border-base-border rounded-lg p-4 border-b-0">
        <div className="flex justify-between items-center pl-3 pb-1">
          <div className="font-medium text-lg text-base-primary">
            {title}
          </div>
        </div>

        <div className="overflow-hidden flex flex-col max-h-[calc(100vh-280px)] min-h-[500px] w-full">
          <div ref={scrollContainerRef} className="overflow-y-auto flex-1 w-full">
            <DataTable
              className="w-full"
              key={`table-${data.length}`}
              enableColumnResizing={enableColumnResizing}
              stickyHeader={stickyHeader}
              data={data}
              columns={memoizedColumns}
              rowIdIdentifier={rowIdIdentifier}
              isLoading={isLoading}
              showPagination={showPagination}
              rowsPerPage={rowsPerPage}
            />
          </div>
        </div>
      </div>
    </div>
  );
};


